export enum SignalrEvent {
  OrderUpdated = 'Order_Updated',
  BleButtonPressed = 'Ble_Button_Pressed',
  DeviceImportStatusChanged = 'Device_Import_Status_Changed',
  ImportStatusChanged = 'Import_Status_Changed',
  NotificationAdded = 'Notification_Added',
  UnpairedBleButtonPressed = 'Unpaired_Ble_Button_Pressed',
  PatientUpdated = 'Patient_Updated',
  PatientInsuranceUpdated = 'PatientInsurance_Updated',
}
